import { useState } from "react";
import styles from './ExamplesMenu.module.css';

const RegionalSearch = ({ onRegionSelect, activeRegion, isOpen: externalIsOpen, onToggle }) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;
  
  const handleToggle = () => {
    const newState = !isOpen;
    if (onToggle) {
      onToggle(newState);
    } else {
      setInternalIsOpen(newState);
    }
  };

  // Benzersiz ilçe isimleri (alfabetik sıralı)
  const regions = [
    "Akyurt",
    "Beypazarı",
    "Çankaya",
    "Elmadağ",
    "Etimesgut",
    "Gölbaşı",
    "Haymana",
    "Keçiören",
    "Kazan",
    "Mamak",
    "Nallıhan",
    "Polatlı",
    "Pursaklar",
    "Sincan",
    "Yenimahalle"
  ];

  return (
    <div className={styles.menuContainer} style={{ top: '100px' }}>
      <button 
        className={styles.menuButton}
        onClick={handleToggle}
      >
        🔍 Bölgesel Arama
      </button>
      
      {isOpen && (
        <div className={styles.menuDropdown}>
          <div className={styles.menuHeader}>
            <p>İlçe Seçiniz</p>
          </div>
          
          <div className={styles.examplesList}>
            {regions.map(region => (
              <div
                key={region}
                className={`${styles.exampleItem} ${activeRegion === region ? styles.active : ''}`}
                onClick={() => {
                  onRegionSelect(region);
                  if (onToggle) onToggle(false);
                  else setInternalIsOpen(false);
                }}
              >
                <div 
                  className={styles.exampleColor}
                  style={{ backgroundColor: '#2980b9' }}
                ></div>
                <div className={styles.exampleContent}>
                  <h4>{region}</h4>
                </div>
              </div>
            ))}
          </div>
          
          <div className={styles.menuFooter}>
            <p>© Pronuve</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegionalSearch;
